import React from "react";

import {
    Route,
    Navigate,
} from "react-router-dom";
import { useAppSelector } from "./store/hooks/hooks";
import { getToken } from "./utils/helperFunction";

const PrivateRoutes:React.FC<any> = ({children,...rest}) => {
    const {token, loading } = useAppSelector((state) => state.auth)
    if(loading){
        return (
            <div>
                Loading...
            </div>
        )
    }
    return(
        token || Object.keys(getToken() || {}).length >0 ? (children) : (
            <Navigate
                to={{
                  pathname: "/login",
                }}
              />
        )
    )
}
export default PrivateRoutes